/**
 * @module lib/inwd
 *
 * Where the INWD console lives. The backend registers the console as a fixed
 * OAuth client at this origin (backend/src/config/oauth.js); a build may point
 * a test deployment elsewhere with VITE_INWD_CONSOLE_URL. Nothing a visitor
 * sends can change it, so redirecting there is never an open redirect.
 */

const configured = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_INWD_CONSOLE_URL : undefined;

/** @type {string} */
export const INWD_CONSOLE_URL = configured || 'https://console.inwd.org/';
